export default __webpack_public_path__ + "static/media/mobile-illustration.ce09700c.png";